/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown>, required: NonNullable<unknown> }} Player_Score_NeededInputs */

const en_player_score_needed = /** @type {(inputs: Player_Score_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score: ${i?.score}% (${i?.required}% needed)`)
};

const ja_player_score_needed = /** @type {(inputs: Player_Score_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`得点: ${i?.score}% (必要: ${i?.required}%)`)
};

const fr_player_score_needed = /** @type {(inputs: Player_Score_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Score : ${i?.score}% (${i?.required}% requis)`)
};

const de_player_score_needed = /** @type {(inputs: Player_Score_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Punktzahl: ${i?.score}% (${i?.required}% benötigt)`)
};

/**
* | output |
* | --- |
* | "Score: {score}% ({required}% needed)" |
*
* @param {Player_Score_NeededInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_score_needed = /** @type {((inputs: Player_Score_NeededInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Score_NeededInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_score_needed(inputs)
	if (locale === "ja") return ja_player_score_needed(inputs)
	if (locale === "fr") return fr_player_score_needed(inputs)
	return de_player_score_needed(inputs)
});